import Slider from "@/components/Slider";
import Card from "@/components/Card/index";
import { useRtRecommendQuery } from "@/hooks";

export default function RtRecommendSlider({ elementId, header }) {
  const { data, ...result } = useRtRecommendQuery({
    variables: {
      location: `${window.location.origin}${window.location.pathname}`,
      elementIds: [elementId],
    },
    fetchPolicy: "cache-first",
  });

  if (!data?.recommend) return null;

  const items = data?.recommend.find((data) => data.elementId === elementId);

  return (
    <Slider header={header} itemComponent={Card} items={items} {...result} />
  );
}
